document.onkeydown = checkKey;

const left = document.getElementById("left").getAttribute("href");
const right = document.getElementById("right").getAttribute("href");
const galleryclose = document.getElementById("galleryclose").getAttribute("href");

function checkKey(e) {
  e = e || window.event;

  if (e.keyCode == "88" || e.keyCode == "67" || e.keyCode == "27") {
    e.preventDefault();
    window.location.href = galleryclose;
  } else if (e.keyCode == "37") {
    window.location.href = left;
  } else if (e.keyCode == "39") {
    window.location.href = right;
  }
}
